"use client";


// src/libraries/react/client/clientCusMethods.ts
var createCustomerMethod = async ({
  client,
  params
}) => {
  let result = await client.post("/api/autumn/customers", params);
  return result;
};

export {
  createCustomerMethod
};
